import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ImageModule } from 'primeng/image';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { UsersService } from '../../../shared/services/users.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    InputTextModule,
    ButtonModule,
    ImageModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  isLoading = false;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private usersService: UsersService,
    private messageService: MessageService
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit() {
    // Component initialization if needed
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';

      const formValue = this.forgotPasswordForm.value;
      
      // Call the API using the users service
      this.usersService.sendForgotPasswordEmail(formValue.email, "").subscribe({
        next: (response) => {
          this.isLoading = false;
          
          // Show success toaster with the message from API response
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: response.message || 'Password reset link has been sent to your email address.',
            life: 5000
          });
          
          // Clear the form
          this.forgotPasswordForm.reset();
        },
        error: () => {
          this.isLoading = false;
          
          // Show error toaster
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to send password reset email. Please try again.',
            life: 5000
          });
        }
      });
    } else {
      // Mark all fields as touched to show validation errors
      this.forgotPasswordForm.markAllAsTouched();
    }
  }
}
